import React, { useEffect, useState } from 'react';
import { UpsellItemsContainer } from './upsell-items/upsell-items.jsx';
import { Content } from '../components/content.jsx';
import { DiscountBadge } from '../components/discount-badge.jsx';
import { CartItems } from '../components/cart-items/cart-items.jsx';
import { Notification, DELAY_5_S } from '../../design-system/notification.jsx';
import { NOTIFICATION_EVENTS } from '../../../custom-events/notification';
import { checkIsRegularCartPage } from '../helpers/checkPage';
import EmptyState from '../components/empty-state.jsx';

export const ContentContainer = ({ cart }) => {
  const [text, setText] = useState('');
  const [isVisible, setVisibility] = useState(false);
  const isCartEmpty = cart.item_count === 0;
  const isRegularCartPage = checkIsRegularCartPage();

  const handleClose = () => {
    setVisibility(false);
  };

  const handleNotification = ({ detail }) => {
    setText(detail.text);
    setVisibility(true);
    setTimeout(handleClose, DELAY_5_S);
  };

  useEffect(() => {
    document.addEventListener(NOTIFICATION_EVENTS.SEND, handleNotification);

    return () => {
      document.removeEventListener(NOTIFICATION_EVENTS.SEND, handleNotification);
    };
  }, []);

  return (
    <Content>
      {isCartEmpty ? (
        <EmptyState />
      ) : (
        <>
          <DiscountBadge />
          <CartItems items={cart.items} />
          {isRegularCartPage && <UpsellItemsContainer />}
          {isVisible && <Notification text={text} onClose={handleClose} />}
        </>
      )}
    </Content>
  );
};
